import {
  NEW_CHATVISOR,
  REMOVE_CONVERSATION,
  NEW_MESSAGE_CHAT_VISOR,
  SET_VIEW_LIST_SUPERVISORS,
  SET_SUPERVISOR_CONNECTED_ON_CHAT,
  RESET_CHATVISOR,
} from '@/store/mutation-types';

const mutations = {
  [NEW_CHATVISOR](state, conversation) {
    state.chats.push(conversation);
  },

  [NEW_MESSAGE_CHAT_VISOR](state, { message, supervisorId }) {
    const findChatVisorBySupervisorId = (supervisorId) => (conversation) =>
      conversation.supervisorId === supervisorId;
    const indexChatVisor = state.chats.findIndex(
      findChatVisorBySupervisorId(supervisorId),
    );

    state.chats[indexChatVisor].messages.push(message);
  },

  [SET_SUPERVISOR_CONNECTED_ON_CHAT](state, { connected, chatVisorUser }) {
    state.chats.map((chat) => {
      if (chatVisorUser == chat.chatVisorUser) {
        chat.supervisorConnectedOnChat = connected;
      }
      return chat;
    });
  },

  [REMOVE_CONVERSATION](state, chatvisorUser) {
    const removeChatVisor = (chatvisorUser) => (conversation) =>
      conversation.chatvisorUser != chatvisorUser;
    state.chats = state.chats.filter(removeChatVisor(chatvisorUser));
  },

  [SET_VIEW_LIST_SUPERVISORS](state, show) {
    state.viewListSupervisors = show;
  },

  [RESET_CHATVISOR](state) {
    state.viewListSupervisors = false;
    state.chats = [];
  },
};

export default mutations;
